import t from '@jetshop/intl';
import React from 'react';
import { styled } from 'linaria/react';

const StyledDescription = styled('p')`
    align-items: center;
    justify-content: center;
    display: flex;
    max-width: 50%;
    margin: 0 auto;

  @media screen and (max-width: 800px) {
    max-width: 100%;
  }
`;

export const Main3DDescription = () => {
  return (
    <StyledDescription>
      {t('Den är en av hemmets viktigaste möbler. Den är en plats för gemenskap och vila. Den är vardagsrummets centrum som sätter tonen för känslan i rummet, så välj din soffa med omsorg. Är du ute efter en 3-sits soffa, en hörnsoffa...')}
    </StyledDescription>
  );
};